export function ensureType<TValue, TCastValue = TValue>(value: TValue): TCastValue {
	return <TCastValue><unknown>value;
}
